const No_Record_String = 'No records found matching your filter...';

module.exports = {
  No_Record_String: No_Record_String,
};
